import { z } from 'zod'

export const SnapshotRetentionConfigSchema = z.object({
  type: z.literal('months'),
  // システムとして10年を最大値としておく (変更要望があれば対応)
  keepMonths: z.number().int().min(1).max(120),
})

export type SnapshotRetentionConfig = z.infer<typeof SnapshotRetentionConfigSchema>
